exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".settings-loader {\n  height: 50vh;\n}\n.w-100 {\n  -webkit-flex-wrap: wrap;\n          flex-wrap: wrap;\n}\n.w-100 .textarea {\n  width: 100%;\n}\n.w-100 .textarea textarea {\n  width: calc(100% - 40px);\n  height: 25vh;\n  margin-top: 30px;\n  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.04);\n  min-height: 120px;\n  border-radius: 4px;\n  border: 1px solid rgba(0, 0, 0, 0.16);\n  padding: 20px;\n  font-size: 16px;\n}\n.w-100 .save-button-container {\n  margin-top: 30px;\n  margin-left: auto;\n}", ""]);

// exports
